import React from "react";
import { useDispatch } from "react-redux";

import { configuratorActions } from '../../../store/configurator-slice';

function ProgressStep(props) {
  const dispatch = useDispatch();

  const stepClickHandler = () => {
    dispatch(
      configuratorActions.setFormStep(props.step.stepName)
    );
  };

  if (props.step.stepTabVisible) {
    return (
      <div className={`step-item ${props.current ? "step-item-active" : ""}`}>
        <div className="step-title">{props.step.stepTabLabel}</div>
        <button
          className={`step-button text-center ${
            props.current ? "step-button-active" : ""
          } ${props.step.stepCompleted ? "done" : ""}`}
          type="button"
          disabled={!props.step.stepTabEnabled}
          onClick={stepClickHandler}
        >
          &nbsp;
        </button>
      </div>
    );
  }
}

export default ProgressStep;
